import { Eye, MousePointerClick, Wallet } from "lucide-react";
import type { ReactNode } from "react";

type CampaignPerformanceMetricsProps = {
  spend: string;
  impressions: string;
  ctr: string;
  className?: string;
};

const metricIconClassName = "tw:h-4 tw:w-4 tw:text-muted-foreground/80";

function MetricCard({
  label,
  value,
  icon,
}: {
  label: string;
  value: string;
  icon: ReactNode;
}) {
  return (
    <div className="tw:rounded-xl tw:border tw:bg-muted/30 tw:px-4 tw:py-3">
      <div className="tw:mb-2 tw:flex tw:items-center tw:gap-2 tw:text-xs tw:font-medium tw:uppercase tw:tracking-[0.18em] tw:text-muted-foreground">
        {icon}
        <span>{label}</span>
      </div>
      <p className="tw:text-lg tw:font-semibold tw:text-foreground sm:tw:text-xl">
        {value}
      </p>
    </div>
  );
}

export function CampaignPerformanceMetrics({
  spend,
  impressions,
  ctr,
  className,
}: CampaignPerformanceMetricsProps) {
  return (
    <div
      className={["tw:grid tw:grid-cols-3 tw:gap-3", className]
        .filter(Boolean)
        .join(" ")}
    >
      <MetricCard
        label="Budget Spent"
        value={spend}
        icon={<Wallet className={metricIconClassName} />}
      />
      <MetricCard
        label="Impressions"
        value={impressions}
        icon={<Eye className={metricIconClassName} />}
      />
      <MetricCard
        label="CTR"
        value={ctr}
        icon={<MousePointerClick className={metricIconClassName} />}
      />
    </div>
  );
}
